import React from 'react';

import SvgIcon from './SvgIcon';

const IconDelete = (props: React.SVGAttributes<SVGSVGElement>) => (
  <SvgIcon viewBox="0 0 11 12" {...props}>
    <path
      d="M1 4v6.4c0 .88.68 1.6 1.5 1.6h6c.82 0 1.5-.72 1.5-1.6V4H1zm7.25-2.2V.6c0-.36-.28-.6-.69-.6H3.44c-.41 0-.69.24-.69.6v1.2H0V3h11V1.8H8.25zM7 2H4V1h3v1z"
      fill="#BB4040"
    />
  </SvgIcon>
);

export default IconDelete;
